import { useNavigate } from "react-router-dom";
import howToPlayImage from "../images/how-to-play.png";
import { useGameStore } from "../store/gameStore";

const HowToPlay = () => {
  const navigate = useNavigate();
  const { startGame } = useGameStore();

  return (
    <div className="flex flex-col relative justify-between">
      <section className="flex-1 flex items-center justify-center px-4 mt-5">
        <button className="flex justify-center" onClick={() => {
          startGame();
          navigate("/monster-encyclopedia");
        }}>
          <img
            src={howToPlayImage}
            alt="게임 방법 설명"
            className="w-[90%] h-auto object-contain rounded-lg"
          />
        </button>
      </section>

      <footer className="flex flex-col items-center justify-center pt-10 px-4">
        <p className="text-sm text-gray-900 font-semibold">
          Copyright © 2025 Cremond, Inc. All rights reserved.
        </p>
      </footer>
    </div>
  );
};

export default HowToPlay;
